<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Contents</p>
<p class="toc"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">1. Bailey House</a></p>
<p class="toc"><a href="#/chapter02">2. Brielmaier and Foretich Houses</a></p>
<p class="toc"><a href="#/chapter03">3. Creole Cottage</a></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. Dantzler House</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. Father Ryan House</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. Fisherman’s Cottage</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. Pleasant Reed House</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. Old Mud Daub House: Biloxi’s Oldest Home</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. Old Brick House</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. Old Spanish House</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. Gunston Hall/White Pillars</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. Tullis-Toledano Manor and the Manor Families</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">13. Palmer House</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">14. Edgewater Gulf Hotel</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">15. Avelez Hotel</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">16. Tivoli Hotel</span></p>
<p class="toc"><span href="#/chapter17" title="Link target outside of Sample">17. White House Hotel</span></p>
<p class="toc"><span href="#/chapter18" title="Link target outside of Sample">18. Magnolia Hotel: Queen of the Watering Holes</span></p>
<p class="toc"><span href="#/chapter19" title="Link target outside of Sample">19. Baricev’s Seafood Harbor Restaurant and Lounge</span></p>
<p class="toc"><span href="#/chapter20" title="Link target outside of Sample">20. Gus Stevens Restaurant and Supper Club</span></p>
<p class="toc"><span href="#/chapter21" title="Link target outside of Sample">21. Friendship House Restaurant</span></p>
<p class="toc"><span href="#/chapter22" title="Link target outside of Sample">22. Baldwin Wood Lighthouse</span></p>
<p class="toc"><span href="#/chapter23" title="Link target outside of Sample">23. Biloxi’s USO and Community Center</span></p>
<p class="toc"><span href="#/chapter24" title="Link target outside of Sample">24. Biloxi’s City Hall and Market</span></p>
<p class="toc"><span href="#/chapter25" title="Link target outside of Sample">25. Pizzati Pavilion and the L&amp;N Park</span></p>
<p class="toc"><span href="#/chapter26" title="Link target outside of Sample">26. Point Cadet Plaza and the Maritime and Seafood Industry Museum</span></p>
<p class="toc"><span href="#/chapter27" title="Link target outside of Sample">27. Eight Flags</span></p>
<p class="toc1"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2ee07190